import React, { useEffect } from 'react';
import { useTitle } from '../../../context/TitleContext';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { motion } from 'framer-motion';
import { FaEdit, FaEye } from 'react-icons/fa';
import { showSuccessToast, showErrorToast } from '../../../shared/utils/toastHelper';
import { fetchCountries, clearError, clearSuccess } from '../../../redux/Slices/LocationsSlice';

const Countries = () => {
    const { setTitle } = useTitle();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { countries, loading, error, success } = useSelector((state) => state.locations);

    useEffect(() => {
        setTitle('الدول');
        dispatch(fetchCountries());
    }, [setTitle, dispatch]);

    useEffect(() => {
        if (error) {
            showErrorToast(error);
            dispatch(clearError());
        }
        if (success) {
            showSuccessToast(success);
            dispatch(clearSuccess());
        }
    }, [error, success, dispatch]);

    const handleEdit = (id) => {
        navigate(`/admin-locations/countries/${id}/edit`);
    };

    const handleView = (id) => {
        navigate(`/admin-locations/countries/${id}`);
    };

    const handleAdd = () => {
        navigate(`/admin-locations/countries/add`);
    };

    return (
        <div className="main_content">
            <div className="dashboard-container">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h4 className="mb-0">إدارة الدول</h4>
                    <button className="btn btn-primary px-4 py-2" onClick={handleAdd}>
                        إضافة دولة +
                    </button>
                </div>

                <div className="card shadow-lg border-0">
                    <div className="card-body">
                        {loading ? (
                            <div className="text-center py-5">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                <p className="mt-3 text-muted">جاري تحميل الدول...</p>
                            </div>
                        ) : !countries || countries.length === 0 ? (
                            <div className="text-center py-5">
                                <p className="text-muted">لا توجد دول مضافة حالياً</p>
                            </div>
                        ) : (
                            <div className="table-responsive">
                                <table className="table table-modern">
                                    <thead>
                                        <tr>
                                            <th className="text-center">الرقم التعريفي</th>
                                            <th className="text-center">اسم الدولة</th>
                                            <th className="text-center">الإجراءات</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {countries.map((country) => (
                                            <tr key={country.id} className="table-row-modern">
                                                <td className="text-center">
                                                    <div className="order-number-badge">
                                                        {country.id}
                                                    </div>
                                                </td>
                                                <td className="text-center">
                                                    <div className="category-name">
                                                        {country.name || country.name_ar || country.name_en || 'غير محدد'}
                                                    </div>
                                                </td>
                                                <td className="text-center">
                                                    <div className="action-buttons">
                                                        <motion.button
                                                            whileHover={{ scale: 1.1, y: -2 }}
                                                            whileTap={{ scale: 0.95 }}
                                                            className="btn btn-success"
                                                            style={{
                                                                width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '8px'
                                                            }}
                                                            onClick={() => handleView(country.id)}
                                                            title="عرض">
                                                            <FaEye color="white" />
                                                        </motion.button>
                                                        <motion.button
                                                            whileHover={{ scale: 1.1, y: -2 }}
                                                            whileTap={{ scale: 0.95 }}
                                                            className="btn btn-warning"
                                                            style={{
                                                                width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '8px'
                                                            }}
                                                            onClick={() => handleEdit(country.id)}
                                                            title="تعديل">
                                                            <FaEdit color="white" />
                                                        </motion.button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Countries;
